/** A more efficient omit function than the deprecated lodash omit */
export const omit = (obj, k) => {
    if (!obj)
        return {};
    const newObj = {};
    const paths = new Set(Array.isArray(k) ? k : [k]);
    for (const key of Object.keys(obj)) {
        if (paths.has(key))
            continue;
        newObj[key] = obj[key];
    }
    return newObj;
};
//# sourceMappingURL=omit.js.map